import { computed, effect, inject, Service } from "@angular/core";
import { patchState, signalState } from "@ngrx/signals";
import { SpinnerComponent } from "./components/spinner/spinner.component";
import { Overlay, OverlayRef } from "@angular/cdk/overlay";
import { ComponentPortal } from "@angular/cdk/portal";

@Service()
export class SpinnerService {
    private _overlay = inject(Overlay);
    private _overlayRef: OverlayRef = this._overlay.create({
        scrollStrategy: this._overlay.scrollStrategies.block(),
    });
    private _spinnerComponentPortal = new ComponentPortal(SpinnerComponent);

    private _state = signalState<{ requests: number }>({
        requests: 0,
    });

    public isLoading = computed(() => this._state().requests > 0);

    constructor() {
        effect(() => this.onLoadingStatusChanged());
    }

    public addRequest(): void {
        patchState(this._state, (state) => ({ requests: state.requests + 1 }));
    }

    public removeRequest(): void {
        patchState(this._state, (state) => ({ requests: state.requests - 1 }));
    }

    private onLoadingStatusChanged(): void {
        if (this.isLoading()) {
            if (!this._overlayRef.hasAttached()) {
                this._overlayRef.attach(this._spinnerComponentPortal);
            }
        } else {
            this._overlayRef.detach();
        }
    }
}
